import { Tabs } from '@components/moleculs/tabs';
import styled from 'styled-components';

export const SteppedTabsContainer = styled(Tabs)`
    &.MuiTabs-root {
        overflow: inherit;
    }

    .MuiTab-root {
        cursor: auto;
    }

    .MuiTabs-scroller {
        overflow: inherit !important;
    }

    .MuiTabs-indicator {
        display: none;
        height: 6px;
    }

    .tab__item {
        flex-grow: 1;
        position: relative;

        ${(props) => props.theme.breakpointTo.sm} {
            margin-bottom: 10px;
        }

        .MuiButtonBase-root {
            color: ${(props) => props.theme.palette.secondaryA8};
        }

        &.success-tab {
            .MuiButtonBase-root {
                color: ${(props) => props.theme.palette.secondaryA3};
            }

            &:after {
                background: ${(props) => props.theme.palette.secondaryA3};
            }
        }

        &.current-tab {
            .MuiButtonBase-root {
                color: ${(props) => props.theme.palette.primaryA1};
            }

            &:after {
                background: ${(props) => props.theme.palette.primaryA1};
            }
        }

        &:after {
            position: absolute;
            content: '';
            width: 100%;
            height: 6px;
            border-radius: 8px;
            left: 0;
            bottom: -8px;
            background: ${(props) => props.theme.palette.secondaryA8};
        }
    }
`;
